import {
  Adjustments,
  CalendarTime,
  CalendarV3,
  LivancePay,
  TimeLoop,
  Graph,
  CloseSchedule,
} from "@repo/icons";
import {
  FullScreenModal,
  FullScreenModalDescription,
  FullScreenModalHeader,
  FullScreenModalTitle,
} from "@/components/full-screen-modal.tsx";
import {
  FullScreenListOption,
  FullScreenListOptionList,
  FullScreenListOptionTitle,
} from "@/components/full-screen-modal-list-option.tsx";

interface FullScreenModalHomeProps {
  isOpen: boolean;
  onClose: () => void;
}

export const FullScreenModalHome = ({
  isOpen,
  onClose,
}: FullScreenModalHomeProps): JSX.Element => {
  const menuOptions = [
    {
      title: "Novo agendamento",
      icon: CalendarV3,
      route: "/appointment/create",
    },
    {
      title: "Configurar agendas",
      icon: Adjustments,
      route: "/settings/schedule-options/schedules",
    },
    {
      title: "Fechar agenda",
      icon: CloseSchedule,
      route: "/calendar/unavailable-slots/create",
    },
    {
      title: "Histórico de uso",
      icon: TimeLoop,
      route: "/settings/billing",
    },
    {
      title: "Livance Pay",
      icon: LivancePay,
      route: "/settings/payments",
    },
    {
      title: "Livance Assist",
      icon: Graph,
      route: "/settings/assist",
      search: { from: "/home" },
    },
    {
      title: "Período garantido",
      icon: CalendarTime,
      route: "/settings/reserved-schedules",
    },
  ];

  return (
    <FullScreenModal isOpen={isOpen} onClose={onClose}>
      <FullScreenModalHeader>
        <FullScreenModalTitle>O que você precisa hoje?</FullScreenModalTitle>
        <FullScreenModalDescription>
          Veja tudo o que você pode fazer por aqui
        </FullScreenModalDescription>
      </FullScreenModalHeader>

      <FullScreenListOptionList>
        {menuOptions.map((option, index) => (
          <FullScreenListOption
            key={option.title}
            index={index}
            route={option.route}
            search={option.search}
          >
            <option.icon size={24} className="fill-primary-500" />
            <FullScreenListOptionTitle>{option.title}</FullScreenListOptionTitle>
          </FullScreenListOption>
        ))}
      </FullScreenListOptionList>
    </FullScreenModal>
  );
};
